import React, { useState } from "react";

import { isEmpty } from "lodash/fp";

import Collapse from "@mui/material/Collapse";

import { splitParagraphs } from "@app/common/utils";

import SeeMoreButton from "@rui/SeeMoreButton";
import Stack from "@rui/Stack";

import { Note } from "./styles";

export const BUTTON_PROPS = {
  viewMoreLabel: "View more",
  viewLessLabel: "View less",
};

const ExpandableSummary = ({ value }: { value: string }) => {
  const [expanded, setExpanded] = useState(false);

  const [firstParagraph, ...remainingParagraphs] = splitParagraphs(value);

  if (isEmpty(remainingParagraphs)) {
    return <Note>{firstParagraph}</Note>;
  }

  const toggleExpanded = () => setExpanded((e) => !e);

  return (
    <>
      <Note>
        {firstParagraph}
        {/* Paragraphs already end in a "." so just add two more for a full "..." */}
        {expanded ? "" : ".. "}
        <SeeMoreButton
          {...BUTTON_PROPS}
          viewingMore={expanded}
          hide={expanded}
          onClick={toggleExpanded}
        />
      </Note>
      <Collapse in={expanded}>
        <Stack spacing={1} marginTop={1}>
          {remainingParagraphs.map((p) => (
            <Note key={p}>{p}</Note>
          ))}
          <SeeMoreButton
            {...BUTTON_PROPS}
            viewingMore={expanded}
            onClick={toggleExpanded}
          />
        </Stack>
      </Collapse>
    </>
  );
};

export default ExpandableSummary;
